export default {
    resetPasswordExpired: 'ลิงก์เปลี่ยนรหัสผ่านหมดอายุ',
    textPasswordExpired: 'ลิงก์เปลี่ยนรหัสผ่านนี้หมดอายุแล้ว โปรดใช้ลิงก์เปลี่ยนรหัสผ่านล่าสุด หรือขอลิงก์ใหม่ด้านล่าง',
    emailAddress: 'อีเมล',
    enterYourEmailAddress: 'ระบุอีเมล',
    sendEmail: 'ส่ง',
    emailSent: 'ส่งอีเมลสำเร็จ',
    returnToLogIn: 'เข้าสู่ระบบ',
    resetPasswordLink: 'ลิงก์เปลี่ยนรหัสผ่านถูกส่งไปที่',
    notThisEmail: 'ไม่ใช่อีเมลนี้ ?',
    emailAddressIsRequired: 'กรุณากรอกอีเมล',
    emailAddressIsNotValid: 'อีเมลไม่ถูกต้อง'
}
